const deg = ['shoulderSlope']

const isDegMeasurement = (name) => (deg.indexOf(name) !== -1 ? true : false)

export default isDegMeasurement
